(() => {
  if (window.atelierPolicyLoaded) return;
  window.atelierPolicyLoaded = true;
  const endpoint = 'https://udrrkckxysjzigwvzpyx.supabase.co/functions/v1/storefront-policy?slug=castlesonnl';
  const update = async () => {
    const policyPage = document.querySelector('[data-atelier-policy]');
    const status = policyPage?.querySelector('[data-policy-status]');
    try {
      const response = await fetch(endpoint, { credentials: 'omit', cache: 'no-store', signal: AbortSignal.timeout(10000) });
      if (!response.ok) throw new Error('Policy unavailable');
      const policy = await response.json();
      if (policy.version !== 1 || policy.slug !== 'castlesonnl' || !Array.isArray(policy.sections)) throw new Error('Invalid policy');
      document.querySelectorAll('[data-policy-exchange-summary]').forEach(node => { node.textContent = policy.exchangeSummary; });
      if (!policyPage) return;
      const fragment = document.createDocumentFragment();
      const ids = ['policy-shipping', 'policy-returns', 'policy-exchanges'];
      policy.sections.forEach((item, index) => {
        if (typeof item.title !== 'string' || !Array.isArray(item.paragraphs) || item.paragraphs.some(text => typeof text !== 'string')) throw new Error('Invalid policy section');
        const section = document.createElement('section');
        section.id = ids[index] || `policy-section-${index}`;
        const heading = document.createElement('h2');
        heading.textContent = item.title;
        section.append(heading);
        item.paragraphs.forEach(text => {
          const paragraph = document.createElement('p');
          paragraph.textContent = text;
          section.append(paragraph);
        });
        fragment.append(section);
      });
      policyPage.querySelector('[data-policy-content]').replaceChildren(fragment);
      status.textContent = '';
    } catch {
      if (status) status.textContent = 'De actuele voorwaarden zijn tijdelijk niet beschikbaar. Neem contact met ons op voor de voorwaarden bij jouw bestelling. Je kunt je bestelling ook openen in het retourportaal.';
    }
  };
  update();
  document.addEventListener('shopify:section:load', update);
})();